module.exports = __webpack_public_path__ + "static/face_600x400-c7539f92c3de1fb24dc83f67c02d6351.jpg";